<template>
  <div class="box" v-if="videoData.publicitySourceUrl" :style="{background: 'url(' + videoData.backgroundImg + ')', 'background-size': '100% 100%'}">
    <video
      :src="videoData.publicitySourceUrl" 
      id="video"
      controls="controls" 
      x5-video-player-type="h5-page" 
      x5-video-player-fullscreen="false" 
      x5-playsinline="" 
      playsinline=""
      :autoplay="true"
      webkit-playsinline="true"
    >
    </video>
  </div>
</template>

<script>
export default {
  data() {
    return {
      video: 'https://img3.quanyou.com.cn/joy/group1/M00/1B/1D/rB4ChmN_C3qAa-FeAdZJHFLDn24742.m4v',
      videoData: {},
      pageType: 'publicity_data',
    }
  },
  mounted() {
    this.getUrlParames()
    this.$api.h5.publicityInfo(this.pageType)
      .then(res => {
        this.videoData = res.data
      })
  },
  methods: {
    getUrlParames() {
      let fullURL = window.location.href;
      let hash = fullURL.split("?")[1];
      let searchParams = new URLSearchParams(hash);
      this.pageType =searchParams.get('pageType') || 'publicity_data'
    }
  }
}
</script>

<style lang="stylus" scoped>
  .box {
    height: 100vh;
    width: 100%;
    background-size: 100% 100%;
    video {
      width 100%
      height 194px
      margin-top: 190px;
      background #000
      object-fit: fill
    }

  }
</style>